module.exports = __webpack_public_path__ + "img/main_10.2d01b06f.jpg";